// Hide certain inputs from Compass Core
$(document).ready(function() {
    // Hide on panel show
    $(document).on('nc.sidePanel.shown', function (e, result) {
        const hideFormElements = ['state_id']
        for (const hideFormElement of hideFormElements){
            $(`#${hideFormElement}`).closest('.form-group').hide();
        }
        if ($('#language_id').length > 0) {
            $('#language_id').val("nl").change();
        }
        if ($('#country_id').length > 0) {
            $('#country_id').val("166").change();
        }
    });
});
